import {
    BrowserRouter as Router,
    Link,
    Navigate,
    Route,
    Routes,
    useLocation,
    useSearchParams,
    useParams,
} from "react-router-dom";
import paths from "./paths";
import {Home} from "./pages/home/home";
import {Header} from "./shared/header/header";
import {Footer, MobileFooter} from "./shared/footer/footer";
import {Betting, BettingRoot} from "./pages/betting/mutual.betting/new.mutual.betting";
import React, {useEffect} from "react";
import {Register} from "./pages/register/register";
import {Login} from "./pages/login/login";
import {MemberInfo} from "./pages/member/member.info";
import {auth} from "./store/auth.store";
import {modalServiceSubject} from "./services/modal.service";
import {MemberWrapper} from "./pages/member/member.wrapper";
import {MemberTickets} from "./pages/member/member.tickets";
import {ChangePassword} from "./pages/member/member.password.change";
import {BankAccounts} from "./pages/member/member.bank.accounts";
import MemberTransactions from "./pages/member/member.transactions";
import {Results} from "./pages/results/results";
import {newsSubject, path} from "./store/misc.store";
import Deposit from "./pages/deposit/deposit";
import Withdraw from "./pages/withdraw/withdraw";
import {Coupons} from "./pages/tipster/coupons";
import Campaign from "./pages/campaigns/campaign";
import {Support} from "./pages/support/support";
import {Program} from "./pages/program/program";
import CampaignDetail from "./pages/campaigns/campaign-detail";
import {Stream} from "./pages/stream/stream";
import {Agreement} from "./pages/agreement/agreement";
import {Flatpage} from "./pages/flatpage/flatpage";
import {useForceUpdate} from "./services/misc.functions";
import {env, listGamePages, news} from "./constants/global.vars";
import {Storage} from "./services/localstorege.service";
import {isMobile} from "./App";
import {MemberNotificationInfo} from "./pages/member/member.notification.info";
import {Notifications} from "./pages/notifications/notifications";
import {Comments} from "./pages/comments/comments";
import {JockeysStats} from "./pages/jockeys/jockeysStats";
import {HorseStats} from "./pages/jockeys/horseStats";
import {CookieSettings} from "./pages/member/member.cookie.settings";
import {Announcements} from "./pages/announcements/announcements";
import notFoundImage from "./assets/img/not-found.png";
import notFoundIcon from "./assets/icons/not-found-icon.svg";
import {MutualBetslip} from "features/betslip/mutual.service";
import Raffle from "./pages/raffles/raffle";
import {Games} from "./pages/games/games";
import {ScratchCards} from "./pages/games/scratch/scratch.cards";
import Statistics from "./pages/statistics/statistics";
import Enhancements from "./pages/enhancements/enhancement";
import {GiftTicket} from "./pages/giftTicket/gift.ticket";
import Game from "./pages/games/game/game";
import {CouponCodes} from "./pages/couponCodes/coupon.codes";
import {MemberSession} from "./pages/member/member.session";
import VRGames from "./pages/games/vrgames/VRGames";
import {MemberVirtualTickets} from "./pages/member/member.virtual.tickets";
import NumericGames from "./pages/games/numericgames/NumericGames";
import {MemberNumericTickets} from "./pages/member/member.numeric.tickets";
import SisalScratch from "./pages/games/sisal-scratch/SisalScratch";
import {LongtermBetting} from "./pages/betting/longterm.betting/new.longterm.betting";
import {SubHeader} from "./shared/header/sub-header";
import {FOBBetting} from "./pages/betting/fob.betting/new.fob.iddaa.betting";
import AltenarGames from "./pages/games/altenar/AltenarGames";

export function PageNotFound() {
    return (
        <>
            <div className={"page-widget"} style={{marginTop: "5rem"}}>
                <div className={"row"} style={{minHeight: "75vh"}}>
                    <div className={"col-4"}>
                        <img
                            alt={""}
                            className={"position-absolute"}
                            style={{
                                top: "58px",
                                height: "56%",
                            }}
                            src={notFoundImage}
                        />
                    </div>
                    <div
                        className={
                            "col-8 py-5 d-flex flex-column justify-content-center align-items-center align-content-center text-center"
                        }
                    >
                        <img alt={"notFound"} src={notFoundIcon}/>
                        <br/>
                        <h3>
                            ÜZGÜNÜZ,
                            <br/>
                            BU SAYFAYA ŞU AN ULAŞILAMIYOR :({" "}
                        </h3>
                        <br/>
                        <p>Tıkladığın bağlantı bozuk olabilir veya sayfa kaldırılmış olabilir.</p>
                        <br/>
                        <Link to={paths.home.url} className="btn btn-info w-75">
                            Anasayfa'ya Git
                        </Link>
                    </div>
                </div>
            </div>
        </>
    );
}

let metaTags: any = {};
Object.entries(paths).forEach(([key, value]: any) => {
    metaTags[value.url] = value;
});

const URLChangeHandler = () => {
    const {pathname} = useLocation();
    const param = useParams();

    let currentPath = String(pathname);
    const [params] = useSearchParams();
    if (params) {
        if (params.get("utm_source")) {
            Storage.set("utm_source", params.get("utm_source"));
        }
        if (params.get("utm_medium")) {
            Storage.set("utm_medium", params.get("utm_medium"));
        }
        if (params.get("utm_campaign")) {
            Storage.set("utm_campaign", params.get("utm_campaign"));
        }
        if (params.get("utm_content")) {
            Storage.set("utm_content", params.get("utm_content"));
        }
    }

    useEffect(() => {
        setTimeout(() => {
            window.scrollTo(0, 0);
        }, 100);

        path.root = currentPath.split("/")[1] || "/";
        path.full = currentPath;
        const bettingSubpage = currentPath.split("/")[3];

        try {
            let navItems: any = document.getElementsByClassName("navItem");
            for (let nav of navItems) {
                nav.classList.remove("active");
            }
            navItems = document.getElementsByClassName(path.root === "/" ? "anasayfa" : currentPath.replace("/", ""));
            for (let nav of navItems) {
                nav.classList.add("active");
            }
        } catch (e) {
        }

        try {
            if (metaTags.hasOwnProperty(currentPath)) {
                // @ts-ignore
                let metaTag: any = metaTags[currentPath];
                if ("/" + path.root === paths.betting.url) {
                    document.title = [
                        "At Yarışı Bülten | Bahis Yap | At Yarışı | 4Nala",
                        MutualBetslip.getOptions().hippodrome?.keyword,
                        bettingSubpage === "muhtemeller" ? "MUHTEMELLER" : bettingSubpage === "agf" ? "AGF" : "",
                    ]
                        .filter(Boolean)
                        .join(" | ");
                } else {
                    document.title = metaTag.title;
                }

                // @ts-ignore
                document.getElementsByTagName("meta").description.content = metaTag.description;
                // @ts-ignore
                document.getElementsByTagName("meta").keywords.content = metaTag.keywords;
            } else {
                // @ts-ignore
                let metaTag: any = metaTags["/" + currentPath.split("/")[1]];
                if ("/" + path.root === paths.betting.url) {
                    document.title = [
                        "At Yarışı Bülten | Bahis Yap | At Yarışı | 4Nala",
                        MutualBetslip.getOptions().hippodrome?.keyword,
                        bettingSubpage === "muhtemeller" ? "MUHTEMELLER" : bettingSubpage === "agf" ? "AGF" : "",
                    ]
                        .filter(Boolean)
                        .join(" | ");
                } else {
                    document.title = metaTag.title;
                }

                // @ts-ignore
                document.getElementsByTagName("meta").description.content = metaTag.description;
                // @ts-ignore
                document.getElementsByTagName("meta").keywords.content = metaTag.keywords;
            }
        } catch (e) {
            console.error(e);
        }
    }, [currentPath]);

    return null;
};

export function ProtectedRoute({children}: any) {
    if (!auth.member || !auth.token) {
        setTimeout(() => {
            modalServiceSubject.next({
                title: "Lütfen Giriş Yapınız",
                content: "Bu sayfayı görüntülemek için giriş yapmanız gerekmektedir.",
                width: 320,
                confirm: {
                    cancel: {
                        label: "Tamam",
                    },
                },
            });
        }, 100);

        return <Navigate to={paths.login.url}/>;
    }
    return children;
}

export function NewsHandler() {
    const forceUpdate = useForceUpdate();

    useEffect(() => {
        let newsSubject_subscriber = newsSubject.subscribe(() => {
            forceUpdate();
        });
        return () => {
            newsSubject_subscriber.unsubscribe();
        };
    }, []);

    if (news.length > 0) {
        let notSeen = news.filter((n: any) => n.is_seen !== true);
        if (notSeen.length > 0) {
            setTimeout(() => {
                modalServiceSubject.next({
                    title: "Duyuru",
                    content: notSeen[0].photo_web
                        ? `<div><img class={"pointer"} style="width:100%;height:100%"
                     src="${env.accounting_api}/media/${notSeen[0].photo_web}"/></div>`
                        : `<div><h3 class="fs-5 fw-semibold mb-0">${notSeen[0].title}</h3>${notSeen[0].content}</div>`,
                    width: 680,
                    confirm: {
                        cancel: {
                            label: "Kapat",
                        },
                        sure: {
                            label: "Tekrar Gösterme",
                            class: "btn btn-warning",
                            action: () => {
                                notSeen[0].is_seen = true;
                                Storage.set("news", news, 24 * 60 * 60 * 1000);
                            },
                        },
                    },
                });
            }, 100);
        }
    }

    return <></>;
}

function AppRouters() {
    return (
        <>
            <Router>
                <URLChangeHandler/>
                <NewsHandler/>
                <Header/>
                {!isMobile && <SubHeader/>}

                <div style={{
                    minHeight: "85vh",
                }} className={`container mt-1 ${listGamePages.includes(window.location.pathname) ? "p-0" : ""}`}>
                    <Routes>
                        <Route path={paths.home.url} element={<Home/>}/>
                        <Route path={paths.verifyEmail.url} element={<Home/>}/>

                        <Route path={paths.betting.url} element={<BettingRoot/>}/>
                        <Route path={`${paths.betting.url}/:hippodrome`} element={<Betting/>}/>
                        <Route path={`${paths.betting.url}/:hippodrome/:subpage`} element={<Betting/>}/>

                        <Route path={`${paths.fobBetting.url}`} element={<FOBBetting/>}/>
                        <Route path={`${paths.fobBetting.url}/:hippodrome`} element={<FOBBetting/>}/>
                        <Route path={`${paths.fobBetting.url}/:hippodrome/:subpage`} element={<FOBBetting/>}/>

                        <Route path={`${paths.longtermBetting.url}`} element={<LongtermBetting/>}/>
                        <Route path={`${paths.longtermBetting.url}/:hippodrome`} element={<LongtermBetting/>}/>
                        <Route path={`${paths.longtermBetting.url}/:hippodrome/:subpage`} element={<LongtermBetting/>}/>

                        <Route path={paths.resetPassword.url} element={<Home/>}/>

                        <Route path={paths.register.url} element={<Register/>}/>
                        <Route path={paths.login.url} element={<Login/>}/>
                        <Route path={`${paths.login.url}/:nextPage`} element={<Login/>}/>
                        <Route path={paths.results.url} element={<Results/>}/>
                        <Route path={`${paths.results.url}/:date/:hippodrome/:run`} element={<Results/>}/>
                        <Route path={paths.tipsterCoupons.url} element={<Coupons/>}/>
                        <Route path={`${paths.tipsterCoupons.url}/:hippodrome`} element={<Coupons/>}/>
                        <Route path={paths.tipsterComments.url} element={<Comments/>}/>
                        <Route path={paths.announcement.url} element={<Announcements/>}/>
                        <Route path={paths.campaigns.url} element={<Campaign/>}/>
                        <Route path={`${paths.campaigns.url}/:id`} element={<CampaignDetail/>}/>
                        <Route path={paths.enhancements.url} element={<Enhancements/>}/>
                        <Route path={`${paths.enhancements.url}/:id`} element={<Enhancements/>}/>
                        <Route path={paths.program.url} element={<Program/>}/>
                        <Route path={paths.stream.url} element={<Stream/>}/>

                        <Route path={`${paths.stream.url}/:tab`} element={<Stream/>}/>
                        <Route path={`${paths.reportedJokeys.url}`} element={<JockeysStats/>}/>
                        <Route path={`${paths.reportedJokeys.url}/:tab`} element={<JockeysStats/>}/>
                        <Route path={`${paths.horseStats.url}`} element={<HorseStats/>}/>
                        <Route path={`${paths.horseStats.url}/:tab`} element={<HorseStats/>}/>

                        <Route path={`${paths.statistics.url}`} element={<Statistics/>}/>
                        <Route path={`${paths.statistics.url}/:date/:hippodrome/`} element={<Statistics/>}/>

                        <Route path={paths.support.url} element={<Support/>}>
                            <Route path={":page"} element={<Support/>}/>
                            <Route path={":page/:id/"} element={<Support/>}/>
                        </Route>

                        <Route path={paths.agreement.url} element={<Agreement/>}>
                            <Route path={":slug"} element={<Agreement/>}/>
                        </Route>

                        <Route path={`${paths.flatpage.url}/:slug`} element={<Flatpage/>}/>

                        <Route
                            path={`${paths.notifications.url}`}
                            element={
                                <ProtectedRoute>
                                    <Notifications/>
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path={`${paths.memberInfo.url}`}
                            element={
                                <ProtectedRoute>
                                    <MemberWrapper>
                                        <MemberInfo/>
                                    </MemberWrapper>
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path={`${paths.memberSessions.url}`}
                            element={
                                <ProtectedRoute>
                                    <MemberWrapper>
                                        <MemberSession/>
                                    </MemberWrapper>
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path={`${paths.notificationInfo.url}`}
                            element={
                                <ProtectedRoute>
                                    <MemberWrapper>
                                        <MemberNotificationInfo/>
                                    </MemberWrapper>
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path={`${paths.memberTickets.url}`}
                            element={
                                <ProtectedRoute>
                                    <MemberWrapper>
                                        <MemberTickets />
                                    </MemberWrapper>
                                </ProtectedRoute>
                            }
                        >
                            <Route path={":subpage"} element={<MemberTickets/>}/>
                        </Route>
                        <Route
                            path={`${paths.memberVirtualTickets.url}`}
                            element={
                                <ProtectedRoute>
                                    <MemberWrapper>
                                        <MemberVirtualTickets/>
                                    </MemberWrapper>
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path={`${paths.memberNumericTickets.url}`}
                            element={
                                <ProtectedRoute>
                                    <MemberWrapper>
                                        <MemberNumericTickets/>
                                    </MemberWrapper>
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path={`${paths.changePassword.url}`}
                            element={
                                <ProtectedRoute>
                                    <MemberWrapper>
                                        <ChangePassword/>
                                    </MemberWrapper>
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path={`${paths.memberBankAccounts.url}`}
                            element={
                                <ProtectedRoute>
                                    <MemberWrapper>
                                        <BankAccounts/>
                                    </MemberWrapper>
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path={`${paths.memberTransactions.url}`}
                            element={
                                <ProtectedRoute>
                                    <MemberWrapper>
                                        <MemberTransactions/>
                                    </MemberWrapper>
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path={`${paths.deposit.url}`}
                            element={
                                <ProtectedRoute>
                                    <MemberWrapper>
                                        <Deposit/>
                                    </MemberWrapper>
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path={`${paths.withdraw.url}`}
                            element={
                                <ProtectedRoute>
                                    <MemberWrapper>
                                        <Withdraw/>
                                    </MemberWrapper>
                                </ProtectedRoute>
                            }
                        />

                        <Route path={paths.vrhorseracing.url} element={
                            <ProtectedRoute>
                                <AltenarGames/>
                            </ProtectedRoute>
                        }>
                            <Route path={":subpage"} element={<AltenarGames/>}/>
                        </Route>

                        <Route path={paths.vrgames.url} element={
                            <ProtectedRoute>
                                <VRGames/>
                            </ProtectedRoute>
                        }>
                            <Route path={":subpage"} element={<VRGames/>}/>
                        </Route>

                        <Route path={paths.numericgames.url} element={
                            <ProtectedRoute>
                                <NumericGames/>
                            </ProtectedRoute>
                        }>
                            <Route path={":subpage"} element={<NumericGames/>}/>
                            <Route path={":subpage/:subpage2"} element={<NumericGames/>}/>
                        </Route>


                        <Route path={paths.sisalscratch.url} element={
                            <ProtectedRoute>
                                <SisalScratch/>
                            </ProtectedRoute>
                        }>
                            <Route path={":subpage"} element={<SisalScratch/>}/>
                        </Route>


                        <Route path={paths.games.url} element={<Games/>}>
                            <Route path={":subpage"} element={<Game/>}/>
                        </Route>


                        <Route
                            path={paths.scratch.url}
                            element={
                                <ProtectedRoute>
                                    <ScratchCards/>
                                </ProtectedRoute>
                            }
                        >
                            <Route
                                path={":subpage"}
                                element={
                                    <ProtectedRoute>
                                        <ScratchCards/>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path={":subpage/:draw_id/*"}
                                element={
                                    <ProtectedRoute>
                                        <ScratchCards/>
                                    </ProtectedRoute>
                                }
                            />
                        </Route>

                        <Route path={`${paths.cookieSettings.url}`} element={<CookieSettings/>}/>

                        <Route path={paths.raffles.url} element={<Raffle/>}></Route>
                        <Route path={`${paths.raffles.url}/:slug`} element={<Raffle/>}/>
                        <Route path={`${paths.raffles.url}/:draw_id/*`} element={<Raffle/>}/>

                        {/*<Route path={paths.products.url} element={<Products/>}>*/}
                        {/*    <Route path={":id"} element={<Products/>}/>*/}
                        {/*</Route>*/}

                        <Route
                            path={paths.giftTicket.url}
                            element={
                                <ProtectedRoute>
                                    <GiftTicket/>
                                </ProtectedRoute>
                            }
                        />

                        <Route
                            path={paths.couponCode.url}
                            element={
                                <ProtectedRoute>
                                    <CouponCodes/>
                                </ProtectedRoute>
                            }
                        ></Route>

                        <Route path="*" element={<PageNotFound/>}/>
                    </Routes>
                </div>

                <Footer/>

                {isMobile && <MobileFooter/>}
            </Router>
            <div id="backdrop-blur" className="backdrop-blur"></div>
        </>
    );
}

export default AppRouters;
